import { URLS } from '@/config/urls';

/**
 * Returns a full url to an games page
 * @param gameSlug
 * @returns
 */
export const getGameReviewUrl = (gameSlug: string) => {
  return `${URLS.GAMES_ALL}/${gameSlug}/reviews`;
};
